import { render, staticRenderFns } from "./ServiceFeeItem.vue?vue&type=template&id=590ab650"
import script from "./ServiceFeeItem.vue?vue&type=script&lang=js"
export * from "./ServiceFeeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports